// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as GamesIndexRouteImport } from './routes/games/index'
import { Route as InternalMaintenanceRouteImport } from './routes/internal/maintenance'
import { Route as GamesGameIdRouteImport } from './routes/games/$gameId'
import { Route as ChangeLinkRouteImport } from './routes/change.$link'
import { Route as AccountProfileRouteImport } from './routes/account/profile'
import { Route as AccountHistoryRouteImport } from './routes/account/history'
import { Route as AccountDobRouteImport } from './routes/account/dob'
import { Route as AccountAchievementsRouteImport } from './routes/account/achievements'
import { Route as _e2e_LayersRouteImport } from './routes/__e2e__/layers'
import { Route as E2eSegmentLayersRouteImport } from './routes/$e2eSegment/layers'
import { Route as AccountBalanceIndexRouteImport } from './routes/account/balance/index'
import { Route as AccountBalanceWithdrawalRouteImport } from './routes/account/balance/withdrawal'
import { Route as AccountBalancePromocodeRouteImport } from './routes/account/balance/promocode'
import { Route as AccountBalanceDepositRouteImport } from './routes/account/balance/deposit'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const GamesIndexRoute = GamesIndexRouteImport.update({
            id: '/games/',path: '/games/',getParentRoute: () => rootRouteImport
          })
const InternalMaintenanceRoute = InternalMaintenanceRouteImport.update({
            id: '/internal/maintenance',path: '/internal/maintenance',getParentRoute: () => rootRouteImport
          })
const GamesGameIdRoute = GamesGameIdRouteImport.update({
            id: '/games/$gameId',path: '/games/$gameId',getParentRoute: () => rootRouteImport
          })
const ChangeLinkRoute = ChangeLinkRouteImport.update({
            id: '/change/$link',path: '/change/$link',getParentRoute: () => rootRouteImport
          })
const AccountProfileRoute = AccountProfileRouteImport.update({
            id: '/account/profile',path: '/account/profile',getParentRoute: () => rootRouteImport
          })
const AccountHistoryRoute = AccountHistoryRouteImport.update({
            id: '/account/history',path: '/account/history',getParentRoute: () => rootRouteImport
          })
const AccountDobRoute = AccountDobRouteImport.update({
            id: '/account/dob',path: '/account/dob',getParentRoute: () => rootRouteImport
          })
const AccountAchievementsRoute = AccountAchievementsRouteImport.update({
            id: '/account/achievements',path: '/account/achievements',getParentRoute: () => rootRouteImport
          })
const _e2e_LayersRoute = _e2e_LayersRouteImport.update({
            id: '/__e2e__/layers',path: '/layers',getParentRoute: () => rootRouteImport
          })
const E2eSegmentLayersRoute = E2eSegmentLayersRouteImport.update({
            id: '/$e2eSegment/layers',path: '/$e2eSegment/layers',getParentRoute: () => rootRouteImport
          })
const AccountBalanceIndexRoute = AccountBalanceIndexRouteImport.update({
            id: '/account/balance/',path: '/account/balance/',getParentRoute: () => rootRouteImport
          })
const AccountBalanceWithdrawalRoute = AccountBalanceWithdrawalRouteImport.update({
            id: '/account/balance/withdrawal',path: '/account/balance/withdrawal',getParentRoute: () => rootRouteImport
          })
const AccountBalancePromocodeRoute = AccountBalancePromocodeRouteImport.update({
            id: '/account/balance/promocode',path: '/account/balance/promocode',getParentRoute: () => rootRouteImport
          })
const AccountBalanceDepositRoute = AccountBalanceDepositRouteImport.update({
            id: '/account/balance/deposit',path: '/account/balance/deposit',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactsRoute: ContactsRoute,PartnersRoute: PartnersRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,E2eSegmentLayersRoute: E2eSegmentLayersRoute,_e2e_LayersRoute: _e2e_LayersRoute,AccountAchievementsRoute: AccountAchievementsRoute,AccountDobRoute: AccountDobRoute,AccountHistoryRoute: AccountHistoryRoute,AccountProfileRoute: AccountProfileRoute,ChangeLinkRoute: ChangeLinkRoute,GamesGameIdRoute: GamesGameIdRoute,InternalMaintenanceRoute: InternalMaintenanceRoute,GamesIndexRoute: GamesIndexRoute,AccountBalanceDepositRoute: AccountBalanceDepositRoute,AccountBalancePromocodeRoute: AccountBalancePromocodeRoute,AccountBalanceWithdrawalRoute: AccountBalanceWithdrawalRoute,AccountBalanceIndexRoute: AccountBalanceIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)